const rid = 'proxyverse'
const source = 'proxyverse'

const apiBase = 'https://api.proxyverse.net'
// const apiBase = 'http://localhost:3000'

export async function getTokenInfo(token) {
  try {
    const response = await fetch(`${apiBase}/account/token`, {
      method: 'POST',
      // mode: 'no-cors', // no-cors, *cors, same-origin
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        token,
        source,
        rid,
      })
    })
    // console.log('response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('getTokenInfo error', error)
    return { success: false }
  }
}


export async function login(login, pass) {
  try {
    const response = await POST(`${apiBase}/account/login`, {
      type: 'email',
      login,
      pass,
      rid,
    })
    console.log('login response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('login error', error)
    return { success: false }
  }
}

export async function register (login, pass) {
  try {
    const response = await POST(`${apiBase}/account/register`, {
      type: 'email',
      login,
      pass,
      rid,
    })
    console.log('register response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('register error', error)
    return { success: false }
  }
}

export async function resetcode (email) {
  try {
    const response = await POST(`${apiBase}/account/code`, {
      email,
      rid,
    })
    console.log('resetcode response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('resetcode error', error)
    return { success: false }
  }
}

export async function updatePass (code, password) {
  try {
    const response = await POST(`${apiBase}/account/reset`, {
      code,
      password
    })
    console.log('updatePass response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('updatePass error', error)
    return { success: false }
  }
}

export async function otccode (email) {
  try {
    const response = await POST(`${apiBase}/account/otcsend`, {
      email,
      rid,
    })
    console.log('otccode response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('otccode error', error)
    return { success: false }
  }
}

export async function otclogin (email, code) {
  try {
    const response = await POST(`${apiBase}/account/otccheck`, {
      email,
      code,
      rid,
    })
    console.log('otclogin response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('otclogin error', error)
    return { success: false }
  }
}


// *******************************************************
// Subscription & Payments
// *******************************************************

export async function createTransaction(token, amount) {
  try {
    const response = await fetch(`${apiBase}/mcpay/create`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token,
        amount,
        source,
      })
    })
    const data = await response.json()
    console.log('/mcpay/create response', data)
    
    return data
  } catch (error) {
    console.log('create transaction error', error)
    return { success: false }
  }
}

export async function subscriptionInfo(token) {
  try {
    const response = await POST(`${apiBase}/account/subinfo`, {
      token,
      source,
    })
    // console.log('promoCode response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('promoCode error inner', error)
    return { success: false }
  }
}

export async function cancelSubscription (subId, token, reason) {
  try {
    const response = await POST(`${apiBase}/account/cancel`, {
      subId,
      token,
      reason
    })
    console.log('cancelSubscription response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('cancelSubscription error', error)
    return { success: false }
  }
}



// *******************************************************
// WG Configs
// *******************************************************

export async function getStaticConfigsList (token) {
  try {
    const response = await POST(`${apiBase}/account/configs/list`, {
      token
    })
    const data = await response.json()
    console.log('getStaticConfigsList response', data)
    return data
  } catch (error) {
    console.log('getStaticConfigsList error', error)
    return { success: false }
  }
}

export async function deleteStaticConfig (peerId, token) {
  try {
    const response = await POST(`${apiBase}/account/configs/delete`, {
      peerId,
      token
    })
    console.log('deleteStaticConfig response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('deleteStaticConfig error', error)
    return { success: false }
  }
}

export async function createStaticConfig (name, location, token) {
  try {
    const response = await POST(`${apiBase}/account/configs/create`, {
      name,
      location,
      token
    })
    console.log('getStaticConfig response', response)
    const data = await response.json()
    return data
  } catch (error) {
    console.log('getStaticConfig error', error)
    return { success: false }
  }
}



// *******************************************************
// Utils
// *******************************************************

export async function POST(url, body, retry = 0) {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    return response
  } catch (error) {
    console.log('POST error', error)
    console.log('POST retry', retry)
    if (retry < 3) {
      return POST(url, body, ++retry)
    } else {
      throw error
    }
  }
}

export async function qfetch (url, fetchOptions, params = {}) {
  let { retry = 0, retryMax = 3, queue = false, type = null } = params

  try {
    return await fetch(url, fetchOptions)
  } catch (error) {
    console.log('qfetch failed retry', retry, 'error', error)

    if (++retry <= retryMax) {
      await new Promise((resolve, reject) => {
        setTimeout(() => resolve(), 1000)
      })
      return qfetch(url, fetchOptions, { retry, retryMax, queue, type })
    } else {
      // TODO: add to queue and retry later
      // if (queue) { }
      throw error
    }
  }
}

function getBrowserArch() {
  let arch = "unknown";

  if (typeof window.navigator !== 'undefined') {
    if (window.navigator.platform.indexOf('Win') !== -1) {
      if (window.navigator.userAgent.indexOf('WOW64') !== -1 || window.navigator.userAgent.indexOf('Win64') !== -1) {
        arch = "x64";
      } else {
        arch = "x86";
      }
    } else if (window.navigator.platform.indexOf('Mac') !== -1) {
      if (window.navigator.userAgent.indexOf('Macintosh; ARM Mac OS X') !== -1 || window.navigator.userAgent.indexOf('Macintosh; ARM64 Mac OS X') !== -1) {
        arch = "arm64";
      } else {
        arch = "x64";
      }
    } else if (window.navigator.platform.indexOf('Linux') !== -1) {
      if (window.navigator.userAgent.indexOf('Linux aarch64') !== -1) {
        arch = "arm64";
      } else if (window.navigator.userAgent.indexOf('Linux x86_64') !== -1) {
        arch = "x64";
      } else if (window.navigator.userAgent.indexOf('Linux i686') !== -1) {
        arch = "x86";
      } else if (window.navigator.userAgent.indexOf('Linux armv') !== -1) {
        arch = "arm";
      }
    }
  }

  return arch;
}

function getBrowserOS() {
  let os = "unknown";
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;

  if (platform.indexOf('Win') !== -1) {
    os = "Windows";
  } else if (platform.indexOf('Mac') !== -1) {
    os = "macOS";
  } else if (platform.indexOf('Linux') !== -1) {
    os = "Linux";
  } else if (platform.indexOf('Android') !== -1 || userAgent.indexOf('Android') !== -1) {
    os = "Android";
  } else if (platform.indexOf('iPhone') !== -1 || platform.indexOf('iPad') !== -1 || userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPad') !== -1) {
    os = "iOS";
  }

  return os;
}
